import { LoadableAfterPaint } from '@confluence/loadable';

export { ISSUE_CREATE_SIDE_PANEL_ID, ISSUE_CREATE_SIDE_PANEL_WIDTH } from './IssueCreateSidePanel';
export {
	BULK_ISSUE_CREATE_SIDE_PANEL_ID,
	BULK_ISSUE_CREATE_SIDE_PANEL_WIDTH,
} from './BulkCreateSidePanel';

export {
	getValidRange,
	getPageContentRange,
	constructInsertStorageFragmentRequestPayload,
} from './utils/issueInsertionUtils';

export { getClosestTableFromSelection, mapTableToIssues } from './utils/tableUtils';

export { useIsAIIssueCreationEnabled } from './utils/useIsAIIssueCreationEnabled';

export {
	useBulkCreateLoggingEvents,
	AI_BULK_ISSUE_CREATE_FEATURE_NAME,
} from './utils/useBulkCreateLoggingEvents';

export {
	type IssueCreateSidePanelContextType,
	type IssueCreateSidePanelActions,
	useIssueCreateSidePanelContext,
} from './providers/IssueCreateSidePanelContextProvider';

export {
	type BulkIssuesListType,
	useSetIsCreatedWithAi,
	useSetInsertStorageFragmentRequestPayload,
	useSetContentLastModifiedTimestamp,
	useGetContentLastModifiedTimestamp,
} from './providers/BulkCreateContextProvider';

export { useBulkCreateContext } from './providers/BulkCreateContextProvider';

export { type InsertStorageFragmentRequestPayload } from '../src/__types__/InsertStorageFragmentRequestPayload';

export const IssueCreateSidePanel = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-IssueCreateSidePanel" */ '../src/IssueCreateSidePanel'
			)
		).IssueCreateSidePanel,
});

export const BulkCreateSidePanel = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-BulkCreateSidePanel" */ '../src/BulkCreateSidePanel'
			)
		).BulkCreateSidePanel,
});

export { IssueCreateWarningDialog } from './IssueCreateWarningDialog';
export {
	useIsWarningDialogOpen,
	useWarningDialogStateActions,
	WarningDialog,
} from './providers/IssueCreateWarningDialogContextProvider';
export { SingleIssueCreateProvidersWrapper } from './providers/SingleIssueCreateProvidersWrapper';
export { BulkIssueCreateProvidersWrapper } from './providers/BulkIssueCreateProvidersWrapper';
